import React, { useState, useEffect } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { createPost, deletePost, getPostsByPage, getPostsBySearch, updatePostReturnOne } from "../../actions/posts"
import VisibilityIcon from '@material-ui/icons/Visibility';
import Preview from './Preview';
import { Link } from "react-router-dom"
import Speed from './Speed';
import { Button, CircularProgress, Paper, TextField, Backdrop } from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import michi from "../../img/michi.jpg"
import guepardo from "../../img/guepardo.png"
import sonic from "../../img/sonic.png"
import espadas from "../../img/espadas.png"
import Main from './Main';
import { getScores, updateScorePuntos, updateScores } from '../../actions/scores';
import PeopleIcon from '@material-ui/icons/People';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import useStyles from "./styles"
import Lang from "../../Lang"
import Records from "./Records"
import Leaderboard from './Leaderboard';
import { fetchFeed } from '../../api';

const Compete = () => {

  const dispatch = useDispatch()
  const classes = useStyles()

  const initialState = {
    text: "",
    userInput: '',
    symbols: 0,
    finished: false
  }

  const user = JSON.parse(localStorage.getItem("profile"))
  let userId = user?.result?.googleId || user?.result?.userId

  const [state, setState] = useState(initialState)
  const [sec, setSec] = useState(0)
  const [started, setStarted] = useState(false)
  const array = []
  const [intervalo, setIntervalo] = useState()
  const [text, setText] = useState()
  const [url, setUrl] = useState("")
  const [index, setIndex] = useState(0)
  const [atacando, setAtacando] = useState({ victimaId: "", victimaName: "", victimaPuntos: "", victimaMediaCinco: "" })
  const [preparando, setPreparando] = useState(false)
  const [resultado, setResultado] = useState({ puntosDespues: "", puntosOtroDespues: "", difA: "", difB: "", resultado: "" })
  const [ahora, setAhora] = useState("antes")
  const [arrOrigen, setArrOrigen] = useState("")
  const [limitB, setLimitB] = useState(25)
  const [limitU, setLimitU] = useState(25)
  const [viewUser, setViewUser] = useState(false)
  const [openRss, setOpenRss] = useState(false)
  const [probando, setProbando] = useState(false)
  const [probarPosts, setProbarPosts] = useState([])

  let posts = useSelector((state) => state.posts)
  let scores = useSelector((state) => state.scores)

  if (!user) {
    userId = -1
  }

  const myScores = scores.myScores
  const gtScores = scores.gtScores
  const ltScores = scores.ltScores
  if (myScores.scores === null) { myScores.scores = [] }
  const recordsSeen = () => {
    const newRecords = scores.myScores?.records
    newRecords?.forEach(s => {
      s.seen = true
    });
    // el if es solo por si no ha cargado
    if (myScores) {
      dispatch(updateScorePuntos({ id: scores.myScores._id, records: newRecords }))
    }
  }

  /* Timer */
  let startTime

  const startTimer = () => {
    setSec(0)
    startTime = new Date()
    setIntervalo(setInterval(() => {
      tick()
    }, 1000))
  }

  useEffect(() => {
    if (!started && !preparando) {
      clearInterval(intervalo)
    }
  }, [started])

  function getTimerTime() {
    return Math.floor((new Date() - startTime) / 1000)
  }

  const tick = () => setSec(getTimerTime())

  /* -- Timer -- */

  const onRestart = () => {
    setState(initialState)
    setStarted(false)
    setSec(0)
  }

  const onUserInputChange = (e) => {
    if (text) {
      const v = e.target.value;
      setState({
        text: state.text,
        userInput: v,
        symbols: countCorrectSymbols(v),
        finished: state.finished
      })
      onFinish(v)
    }
  }

  const onFinish = (userInput) => {
    if (userInput === text) {
      clearInterval(state.interval)
      uploadTimes(Number(myScores.puntos), Number(atacando.victimaPuntos))
      onRestart()
      setAhora("despues")
    }
  }

  const countCorrectSymbols = (userInput) => {
    const text = state.text.replace(' ', '');
    return userInput.replace(' ', '').split('').filter((s, i) => s === text[i]).length;
  }

  const atacar = (victimaId, victimaName, victimaPuntos, victimaMediaCinco) => {
    onRestart(userId)
    setAtacando({ victimaId: victimaId, victimaName: victimaName, victimaPuntos: victimaPuntos, victimaMediaCinco: victimaMediaCinco })
    setOpen(true)
  }

  // Ra = elo de A, Rb = elo de B, verdict = 1 es victoria de A, verdict = 0 es derrota de A, verdict = 0.5 es empate
  const uploadTimes = (Ra, Rb) => {
    setIntervalo(clearInterval)
    const score = Math.round(((text.length / 5) / sec) * 60)

    // Elo

    let verdict
    if (score > atacando.victimaMediaCinco) {
      verdict = 1
    } else if (score < atacando.victimaMediaCinco) {
      verdict = 0
    } else {
      verdict = 0.5
    }
    let Va, Vb
    if (verdict === 1) {
      Va = 1
      Vb = 0
    } else if (verdict === 0) {
      Va = 0
      Vb = 1
    } else {
      Va = 0.5
      Vb = 0.5
    }
    let Ka = 24
    if (Ra > 2400) { Ka = 16 }
    if (Ra < 2100) { Ka = 32 }
    let Kb = 24
    if (Rb > 2400) { Kb = 16 }
    if (Rb < 2100) { Kb = 32 }

    const Ea = 1 / (1 + Math.pow(10, (Rb - Ra) / 400))
    const Eb = 1 / (1 + Math.pow(10, (Ra - Rb) / 400))
    console.log("Ra: ", Ra, "Rb: ", Rb, "verdict: ", verdict, "Ka", Ka, "Kb", "Va", Va, "Vb", Vb, "Ea", Ea, "Eb", Eb, "Score: ", score, "atacando.mediaCinco", atacando.victimaMediaCinco,)

    const difA = Math.round(Ka * (Va - Ea)) // Puntos ganados o perdidos A
    const difB = Math.round(Kb * (Vb - Eb)) // Puntos ganados o perdidos B

    let Pa = Math.round(Ra + difA) // Puntuacion final de A
    let Pb = Math.round(Rb + difB) // Puntuacion final de B
    if (Pa < 1000) { Pa = 1000 }
    if (Pb < 1000) { Pb = 1000 }

    // Medias
    const myTimes = []
    let media = 0
    let mediaCinco = 0

    myScores.scores.push(Math.round(score))


    let sumArray = 0

    myScores.scores.map(item => {
      sumArray += Number(item)
    })

    media = Math.round(sumArray / myScores.scores.length)

    const lastFive = myScores.scores.slice(Math.max(myScores.scores.length - 5, 0))

    lastFive.map(item => mediaCinco += Number(item))

    mediaCinco = Math.round(mediaCinco / Math.round(lastFive.length))

    //console.log("myTimes: ", myTimes, "score: " + score, "Media: " + media, "Media: " + mediaCinco, "mediaCinco: ")
    let category

    if (mediaCinco > 50) {
      category = "Sonic"
    } else if (mediaCinco < 25) {
      category = "Michi"
    } else {
      category = "Guepardo"
    }

    // Upload
    dispatch(updateScores(
      myScores._id,
      {
        category: category,
        difA: difA,
        difB: difB,
        limitB: limitB,
        limitU: limitU,
        media: media,
        mediaCinco: mediaCinco,
        otherId: atacando.victimaId,
        Pa: Pa,
        Pb: Pb,
        scores: myScores.scores,
      }
    ))
    setResultado({ puntosDespues: Pa, puntosOtroDespues: Pb, difA: difA, difB: difB, resultado: Va })
  }

  const uploadSurrender = (Ra, Rb) => {
    setIntervalo(clearInterval)
    let Va = 0
    let Vb = 1

    let Ka = 24
    if (Ra > 2400) { Ka = 16 }
    if (Ra < 2100) { Ka = 32 }
    let Kb = 24
    if (Rb > 2400) { Kb = 16 }
    if (Rb < 2100) { Kb = 32 }

    const Ea = 1 / (1 + Math.pow(10, (Rb - Ra) / 400))
    const Eb = 1 / (1 + Math.pow(10, (Ra - Rb) / 400))

    const difA = Math.round(Ka * (Va - Ea)) // Puntos ganados o perdidos A
    const difB = Math.round(Kb * (Vb - Eb)) // Puntos ganados o perdidos B

    let Pa = Math.round(Ra + difA) // Puntuacion final de A
    let Pb = Math.round(Rb + difB) // Puntuacion final de B
    if (Pa < 1000) { Pa = 1000 }
    if (Pb < 1000) { Pb = 1000 }

    // Upload
    dispatch(updateScores(myScores._id, { otherId: atacando.victimaId, Pa: Pa, Pb: Pb, limitU: limitU, limitB: limitB, difA: difA, difB: difB }))
    setResultado({ puntosDespues: Pa, puntosOtroDespues: Pb, difA: difA, difB: difB, resultado: Va })
  }
  function getPointsDifference(Ra, Rb) {

    let difVictoria, difDerrota
    for (let verdict = 0; verdict < 2; verdict++) {


      let Va, Vb
      if (verdict === 1) {
        Va = 1
        Vb = 0
      } else if (verdict === 0) {
        Va = 0
        Vb = 1
      }
      let Ka = 24
      if (Ra > 2400) { Ka = 16 }
      if (Ra < 2100) { Ka = 32 }
      let Kb = 24
      if (Rb > 2400) { Kb = 16 }
      if (Rb < 2100) { Kb = 32 }

      const Ea = 1 / (1 + Math.pow(10, (Rb - Ra) / 400))



      if (verdict === 1) {
        difVictoria = Math.round(Ka * (Va - Ea))
        console.log(difVictoria)
      } else if (verdict === 0) {
        difDerrota = Math.round(Ka * (Va - Ea))
        console.log("test")
      }
    }
    return [difVictoria, difDerrota]
  }
  // Para backdrop
  const [open, setOpen] = React.useState(false)
  const handleClose = () => {
    if (ahora === "durante" && text) {
      setAhora("despues")
      let Ra = Number(myScores.puntos)
      let Rb = Number(atacando.victimaPuntos)
      uploadSurrender(Ra, Rb)
    } else {
      setAhora("antes")
      setOpen(false)
    }
  }

  const goDown = () => {
    dispatch(getScores({ userId: userId, limitB: limitB + 25, limitU: limitU }))
    setLimitB(limitB + 25)
  }

  const goUp = () => {
    dispatch(getScores({ userId: userId, limitB: limitB, limitU: limitU + 25 }))
    setLimitU(limitU + 25)
  }

  const handleScroll = (e) => {
    if (user) {
      const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
      const top = e.target.scrollTop === 0;
      if (bottom) {
        goDown()
        e.target.scrollTop = e.target.scrollTop - 10
      } else if (top) {
        goUp()
        e.target.scrollTop = 10
      }
    }
  }

  const empezar = () => {
    setPreparando(false)
    setIntervalo(clearInterval)
    startTimer()
    setStarted(true)
  }

  const openUser = (userId) => {
    setViewUser(true)
    dispatch(getScores({ userId: userId }))
    dispatch(getPostsByPage({ page: 1, limit: 1, userId }))
  }

  const closeUser = (id) => {
    setViewUser(false)
  }

  useEffect(() => {
    if (viewUser !== true) {
      dispatch(getScores({ userId: userId, limitB: limitB, limitU: limitU }))
    }
  }, [viewUser])

  const anadirPost = (itemId, users) => {
    dispatch(updatePostReturnOne(itemId, { users: users, userId: userId, userName: user.result.name, limit: 5, page: 1 }))
  }

  const toggleOpenRss = (key, rss) => {
    setProbando(true)
    getText(rss)
    if (key === openRss) {
      setOpenRss(false)
    } else {
      setOpenRss(key)
    }
  }

  const getText = async (u) => {
    let feed = await fetchFeed(u)
    setProbando(false)
    feed.data.items.forEach(item => {
      array.push(item.title)
      if (feed.data.items.length === array.length) { setProbarPosts(array) }
    });

  }

  return (
    <div className={classes.compete_main}>
      <div className={classes.dir}>
        {viewUser ?
          <Button variant="outlined" className={classes.back_home_container} onClick={() => closeUser()}><ArrowBackIosIcon className={classes.back_home} /></Button>
          :
          <Button onClick={() => recordsSeen()} component={Link} to="/" variant="outlined" className={classes.back_home_container}><ArrowBackIosIcon className={classes.back_home} /></Button>
        }

        <h1 className={classes.title}><Lang props={"Compite"} /></h1>
        <Backdrop className={classes.backdrop} open={open}>
          <Button className={classes.closeButon} onClick={handleClose}><CloseIcon className={classes.close} /></Button>
          <Paper className={classes.paper}>
            {ahora === "antes" &&

              <div className={classes.paper}>
                <h1><Lang props={"¿Seguro que quieres atacar a "} />{atacando.victimaName}?</h1>
                <p className={classes.juego}><Lang props={"Puntos en juego: "} />
                  <span className={classes.arrowUp}>{getPointsDifference(myScores?.puntos, atacando.victimaPuntos)[0]}</span> | <span className={classes.arrowDown}>{getPointsDifference(myScores?.puntos, atacando.victimaPuntos)[1]}</span>
                </p>
                <Button color="primary" variant="contained" onClick={() => setAhora("durante")}><Lang props={"Empezar"} /></Button>

              </div>
            }
            {ahora === "durante" &&
              <div className={classes.paper}>
                {started && <h1>{sec}</h1>}
                <Main setText={setText} onRestart={onRestart} index={index} setUrl={setUrl} setArrOrigen={setArrOrigen} />
                {text ?
                  <>
                    {started ?
                      <>
                        <Preview text={text} userInput={state.userInput} />
                      </>
                      :
                      <>
                        {!preparando && setPreparando(true)}

                        <CountdownCircleTimer
                          isPlaying
                          size={90}
                          duration={2.25}
                          strokeWidth={13}
                          onComplete={() => empezar()}
                          colors={[
                            ['#0c5939', 0.33],
                            ['#68dead', 0.33],
                            ['#ffffff', 0.33],
                          ]}
                        >
                          {({ remainingTime }) => remainingTime}
                        </CountdownCircleTimer>
                      </>
                    }
                    <TextField className={classes.field} label="Escribe aquí" variant="outlined" autoFocus
                      value={state.userInput}
                      onChange={onUserInputChange}
                      placeholder={text ? (
                        "Go!"
                      ) : (
                        "Elige antes un texto!"
                      )}
                      readOnly={state.finished}
                    />
                    <Speed sec={sec} symbols={state.symbols} />
                  </>
                  : <CircularProgress />
                }
              </div>

            }
            {ahora === "despues" &&
              <div className={classes.paper}>
                {resultado.resultado === 1 && <p><Lang props={"¡Has ganado!"} /></p>}
                {resultado.resultado === 0.5 && <p><Lang props={"Empate! Y mira que nunca pasa..."} /></p>}
                {resultado.resultado === 0 && <p><Lang props={"Perdiste..."} /></p>}
                <p className={classes.ganado_fila}>
                  <div className={classes.ganado_columna}>
                    <p><Lang props={"Tú"} /></p>
                    <p> {resultado.puntosDespues} {resultado.difA > 0 && <ArrowUpwardIcon className={classes.arrowUp} />} {resultado.difA === 0.5 && "="} {resultado.difA < 1 && <ArrowDownwardIcon className={classes.arrowUp} />}</p>
                  </div>

                  <div className={classes.ganado_columna}>
                    <p><Lang props={"Oponente"} /></p>
                    <p>{resultado.puntosOtroDespues} {resultado.difB > 0 && <ArrowUpwardIcon className={classes.arrowDown} />} {resultado.difB === 0.5 && "="} {resultado.difB < 1 && <ArrowDownwardIcon className={classes.arrowDown} />}</p>
                    {resultado.puntosOtroDespues === 1000 && "(Punt mín)"}

                  </div>

                </p>
                <p><Lang props={"Puntos: "} />{resultado.difA}</p>
                <hr className={classes.hr} />
                <Button href={url} target="_blank"><Lang props={"Ver noticia"} /></Button>
                <span><Lang props={"Origen: "} /> {arrOrigen} </span>
                <p>{text}</p>
              </div>
            }
          </Paper>
        </Backdrop>
      </div>
      <div className={classes.compete_content}>
        {!viewUser && <Leaderboard />}
        {myScores ? <>
          {(!viewUser && (myScores.userId === userId | userId === -1)) ?
            <div className={classes.scores} onScroll={handleScroll}>
              {(!gtScores || !myScores || !ltScores) ?
                <>
                  <CircularProgress />
                  <h2><Lang props={"Cargando..."} /></h2>
                </>
                :
                <>
                  {
                    !gtScores ?
                      <div>
                        <CircularProgress />
                        <p><Lang props={"Vacío!"} /></p>
                      </div>
                      :
                      (
                        <div>
                          {gtScores.map(item => {
                            return (
                              <Paper className={classes.others_compete_paper}>
                                <div className={classes.others_left}>
                                  {item.category === "Michi" && <Button onClick={() => user && openUser(item.userId)}><img src={michi} className={classes.perfil_otros} /></Button>}
                                  {item.category === "Guepardo" && <Button onClick={() => user && openUser(item.userId)}><img src={guepardo} className={classes.perfil_otros} /></Button>}
                                  {item.category === "Sonic" && <Button onClick={() => user && openUser(item.userId)}><img src={sonic} className={classes.perfil_otros} /></Button>}
                                  <p className={classes.puntos}>{item.puntos}</p>
                                  <div className={classes.arriba}>
                                    <p className={classes.rss_paper_c}>{item.userName}</p>
                                  </div>
                                </div>
                                {item.userId !== userId &&
                                  <div className={classes.right} onClick={() => user && atacar(item._id, item.userName, item.puntos, item.mediaCinco)}>
                                    <Button>{user ? <img src={espadas} className={classes.espadas} /> : <h2>?</h2>} </Button>
                                  </div>
                                }
                              </Paper>
                            )
                          })}
                        </div>
                      )
                  }
                  {
                    !myScores ?
                      <div>
                        <CircularProgress />
                        <p><Lang props={"Vacío!"} /></p>
                      </div>
                      :
                      (
                        <div>
                          {
                            <Paper className={classes.my_compete_paper}>
                              <div className={classes.left}>
                                {myScores.category === "Michi" && <img src={michi} className={classes.perfil} />}
                                {myScores.category === "Guepardo" && <img src={guepardo} className={classes.perfil} />}
                                {myScores.category === "Sonic" && <img src={sonic} className={classes.perfil} />}
                                <h3 className={classes.my_score}>{myScores.puntos}</h3>
                              </div>
                              {user ?
                                <div className={classes.center}>
                                  <div className={classes.arriba}>
                                    <p className={classes.rss_paper_c}>{myScores.userName}</p>
                                    {myScores.userId === userId && <TextField value={myScores.scores} className={classes.center} />}
                                  </div>
                                  <div className={classes.abajo}>
                                    {myScores.userId === userId &&
                                      <>
                                        <p className={classes.rss_paper_c}><Lang props={"PPM Medio histórico: "} />{myScores.media}</p>
                                        <p className={classes.rss_paper_c}><Lang props={"Media 5: "} />{myScores.mediaCinco}</p>
                                      </>
                                    }
                                  </div>
                                </div>
                                :
                                <Button component={Link} to="/auth" variant="contained" color="primary" className={classes.logIn}><Lang props={"Inicia sesión!"} /></Button>}
                            </Paper>
                          }
                        </div>
                      )
                  }

                  {
                    !ltScores ?
                      <div>
                        <CircularProgress />
                        <p><Lang props={"Vacío!"} /></p>
                      </div>
                      :
                      (
                        <div>
                          {ltScores.map(item => {
                            return (
                              <Paper className={classes.others_compete_paper}>
                                <div className={classes.others_left}>
                                  {item.category === "Michi" && <Button onClick={() => user && openUser(item.userId)}><img src={michi} className={classes.perfil} /></Button>}
                                  {item.category === "Guepardo" && <Button onClick={() => user && openUser(item.userId)}><img src={guepardo} className={classes.perfil} /></Button>}
                                  {item.category === "Sonic" && <Button onClick={() => user && openUser(item.userId)}><img src={sonic} className={classes.perfil} /></Button>}
                                  <p className={classes.puntos}>{item.puntos}</p>
                                  <div className={classes.arriba}>
                                    <p className={classes.rss_paper_c}>{item.userName}</p>
                                  </div>
                                </div>
                                {item.userId !== userId &&
                                  <div className={classes.right} onClick={() => user && atacar(item._id, item.userName, item.puntos, item.mediaCinco)}>
                                    <Button>{user ? <img src={espadas} className={classes.espadas} /> : <h2>?</h2>} </Button>
                                  </div>
                                }
                              </Paper>
                            )
                          })}
                        </div>
                      )
                  }
                </>
              }
            </div>
            :
            <Paper className={classes.user_paper}>
              {myScores.userId !== userId ? <>
                <div className={classes.left}>
                  {myScores.category === "Michi" && <img src={michi} className={classes.perfil} />}
                  {myScores.category === "Guepardo" && <img src={guepardo} className={classes.perfil} />}
                  {myScores.category === "Sonic" && <img src={sonic} className={classes.perfil} />}
                  <p>{myScores.puntos}</p>
                </div>

                <div className={classes.center}>
                  <h2 className={classes.rss_paper_c}>{myScores.userName}</h2>
                </div>
                <h2><Lang props={"Noticias guardadas: "} /></h2>
                {posts.myPosts.length ?
                  <div className={classes.paper_container}>
                    {posts.myPosts.map((item, key) => {
                      return (
                        <Paper className={classes.rss_paper} key={key} elevation={6}>
                          {openRss === key ?
                            <>
                              <div className={classes.post_row}>
                                {user ?
                                  <>
                                    {!item.users.find(element => element.userId === userId) ?
                                      <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>
                                      :
                                      <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><CheckCircleOutlineIcon className={classes.add} /></Button>}
                                  </>
                                  : <Button component={Link} to="/auth" className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>}
                                <Button onClick={() => toggleOpenRss(key)}><h2 className={classes.post_title}>{item.title}</h2></Button>
                                <Button href={item.value} target="_blank"><VisibilityIcon /></Button>
                              </div>
                              <div className={classes.post_new_row}>
                                <span className={classes.post_new_tag}>{item.tags.length}<LocalOfferIcon className={classes.tag_icon} /><div className={classes.post_new_tag_content}>{item.tags.map(tag => { return (<button className={classes.post_tag_button}>{tag}</button>) })}</div></span>
                              </div>
                              <div className={classes.post_row}>
                                <p className={classes.post_users}>{item.users.length}<PeopleIcon className={classes.people_icon} /><div className={classes.post_new_users_content}>{item.users.map(user => { return (<button className={classes.post_users_button}>{user.userName}</button>) })}</div></p>
                              </div>
                              <div className={classes.post_news_row}>
                                <h2><Lang props={"Últimas noticias subidas:"} /></h2>
                                {

                                  !probando ?
                                    probarPosts.slice(0, 5).map(item => {
                                      return (
                                        <Paper className={classes.example_news} elevation={3}>
                                          <span>{item}</span>
                                        </Paper>)
                                    })
                                    :
                                    <CircularProgress />
                                }
                              </div>
                            </>
                            :
                            <>
                              <div className={classes.post_row}>
                                {user ?
                                  <>
                                    {!item.users.find(element => element.userId === userId) ?
                                      <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>
                                      :
                                      <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><CheckCircleOutlineIcon className={classes.add} /></Button>}
                                  </>
                                  : <Button component={Link} to="/auth" className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>}
                                <Button onClick={() => toggleOpenRss(key, item.value)}><h2 className={classes.post_title}>{item.title}</h2></Button>
                              </div>
                              <span className={classes.post_tag}>{item.tags.length}<LocalOfferIcon className={classes.tag_icon} /><div className={classes.post_tag_content}>{item.tags.map(tag => { return (<button className={classes.post_tag_button}>{tag}</button>) })}</div></span>
                              <div className={classes.post_row}>
                                <p className={classes.post_users}>{item.users.length}<PeopleIcon className={classes.people_icon} /><div className={classes.post_users_content}>{item.users.map(user => { return (<button className={classes.post_users_button}>{user.userName}</button>) })}</div></p>
                              </div>
                            </>
                          }
                        </Paper>)
                    })}
                  </div>
                  :
                  <h3><Lang props={"Vacío!"} /></h3>
                }
              </>
                : <CircularProgress />}
            </Paper>

          }
        </>
          : <CircularProgress />}
        {!viewUser && <Records />}
      </div>
    </div>
  );
}

export default Compete;
